export default __webpack_public_path__ + "static/media/brandlabs-logo.6705a182.png";